<div class="h-screen flex bg-white">

  <!-- LEFT SIDE — full-bleed brand panel with image, gradient overlay and messaging -->
  <div class="relative hidden md:block md:w-1/2 lg:w-3/5 overflow-hidden">
    <!-- Background image: covers the panel, anchored to center -->
    <img
      alt=""
      aria-hidden="true"
      class="absolute inset-0 h-full w-full object-cover object-[0%_center] scale-105"
      src="/images/Ramashow%202026%20Namur.jpeg"
    >
    <!-- Navy gradient overlay: darkens the bottom so the messaging stays readable -->
    <div class="absolute inset-0 bg-gradient-to-t from-primary-950/90 via-primary-900/40 to-primary-900/10"></div>

    <!-- Brand messaging anchored to the bottom-left -->
    <div [animate.enter]="'slide-in-bottom'" class="absolute inset-x-0 bottom-0 p-12 lg:p-16 text-white">
      <h1 class="text-3xl lg:text-4xl font-semibold leading-tight max-w-lg">
        {{ 'app.login-tagline' | translate }}
      </h1>
      <p class="mt-4 text-base lg:text-lg text-white/80 max-w-md leading-relaxed">
        {{ 'app.login-tagline-sub' | translate }}
      </p>
    </div>
  </div>

  <!-- RIGHT SIDE — authentication panel -->
  <div class="flex flex-col justify-center items-center w-full md:w-1/2 lg:w-2/5 px-6 sm:px-12 py-12">

    <div [animate.enter]="'slide-in-bottom'" class="w-full max-w-sm flex flex-col">

      <!-- Logo + heading -->
      <div class="flex flex-col items-center text-center mb-10">
        <img [height]="300" [width]="600" alt="Logo RAMASOFT" class="h-auto w-96" ngSrc="images/Logo-RAMASOFT-bleu.png">
        <h2 class="mt-8 text-2xl font-semibold text-primary-900">{{ 'app.login-welcome' | translate }}</h2>
        <p class="mt-2 text-sm text-slate-500">{{ 'app.login-subtitle' | translate }}</p>
      </div>

      <!-- Error alert -->
      @if (this.error()) {
        <div [animate.enter]="'slide-in-bottom'"
             class="mb-6 flex items-center gap-3 rounded-xl border border-red-200 bg-red-50 px-4 py-3 text-sm text-red-700">
          <i class="pi pi-exclamation-circle text-base"></i>
          <span>{{ this.error() | translate }}</span>
        </div>
      }

      <!-- Credentials -->
      <div (keydown.enter)="logIn()" class="flex flex-col gap-7">

        <elcia-text-input [autocomplete]="'username'" [control]="fg.controls.email" [label]="'user.email' | translate"/>

        <div>
          <elcia-text-input [autocomplete]="'current-password'" [control]="fg.controls.password"
                            [label]="'user.password' | translate" [type]="'password'"/>
          <div class="flex justify-end pt-2">
            <span (click)="this.openForgotPasswordForm()"
                  class="text-sm text-primary-500 hover:text-primary-700 hover:underline cursor-pointer transition-colors duration-200">
              {{ 'action.forgot-password' | translate }}
            </span>
          </div>
        </div>

        <!-- Full-width primary CTA (forces the inner PrimeNG button to stretch) -->
        <div class="[&_button]:w-full [&_button]:justify-center">
          <elcia-button (onClick)="logIn()"
                        [icon]="'user'"
                        [isLoading]="loginMutation.isPending()"
                        [label]="'action.login' | translate"
                        [size]="'large'"/>
        </div>
      </div>

      <!-- Language selector -->
      <div class="mt-10 pt-6 border-t border-slate-100 flex items-center justify-center">
        <elcia-local-dropdown/>
      </div>
    </div>
  </div>
</div>

@if (this.isForgotPasswordDisplayed()) {
  <elcia-dialog (onAction)="sendResetPasswordEmail()"
                (onClose)="closeForgotPasswordForm()"
                [actionIcon]="'send'"
                [actionLabel]="'action.send' | translate"
                [size]="'small'"
                [title]="'action.forgot-password' | translate">
    <elcia-text-input [control]="resetPasswordEmailControl" [label]="'user.email' | translate"/>
  </elcia-dialog>
}
